module.exports = __webpack_public_path__ + "img/translate.d1ab300f.svg";